import { render, staticRenderFns } from "./PickUpAndReturnStepsForm.vue?vue&type=template&id=36a5f3b8"
import script from "./PickUpAndReturnStepsForm.vue?vue&type=script&lang=js"
export * from "./PickUpAndReturnStepsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports